var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vx-row match-height"},[_c('div',{staticClass:"vx-col w-full"},[_c('vx-card',[_c('vs-tabs',{attrs:{"vs-alignment":"fixed","alignment":"fixed"}},[_c('vs-tab',{attrs:{"label":_vm.$t('EditAgentInfo')}},[_c('edit-legal-agent')],1),(
            _vm.$tabHasPermission(
              'AssignDocument|UnAssignDocument|GetAgentDocuments|GetDocumentSettingsByPartyType'
            )
          )?_c('vs-tab',{attrs:{"label":_vm.$t('UploadDocuments')}},[_c('documents-upload',{attrs:{"mode":"legal"}})],1):_vm._e(),_c('vs-tab',{attrs:{"label":_vm.$t('RecipientInfo')}},[_c('recipient-info')],1)],1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }